import { useCallback, useEffect, useRef, useState } from 'react';
import Status from '../status/status';
import { LicenseStatus, License, ActionStatus, TypeActivity } from '../../types/data';
import { document } from '../../ui-icons/icons';
import { useForm, Controller, FieldValues } from 'react-hook-form';
import Select from 'src/pages/DashboardPage/vpo/ui/select';
import { AnswerOptions } from '../../mocks/data';
import Input from '../../ui/input';
import InputDate from '../../ui/input-date';
import { DateValueType } from 'react-tailwindcss-datepicker';
import AddActionInComponent from 'src/pages/DashboardPage/mytasks/addAction/inComponent';
import TGButton from 'src/components/ui/TGButton';
import { selectItems } from 'src/modules/spItems/selectors';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { SingleUserSelect } from '../SingleUserSelect/SingleUserSelect';
import { selectCurrentUser } from 'src/modules/users/selector';
import { UserSelect } from '../UserSelect/UserSelect';
import TextAreaVPO from 'src/pages/DashboardPage/vpo/ui/textArea';
import { TooltipItem } from 'src/utils/Tooltip';
import AlertInformation from '../alert-information/alert-information';
import { getItemsRequest } from 'src/modules/spItems/api';
import Loading from 'src/components/Loading';
import AlertArchive from '../alert-archive/AlertArchive';
import { calculateValidityPeriod, determineLicenseStatus, formatEmptyLicenseBody, getFormattedDates, getLicenseStatusId, updateValidityPeriod } from '../../utils/licenseStatus';
import FileUploader from '../upLoadFiles/FileUploader';
import { emailAPI } from "src/utils/api.utils";
import moment from "moment";
import { emailQueueListName } from 'src/api/config/email.config';
import { paramsListName, siteUrl } from 'src/api/config';
import { mode } from 'src/constants';
import { selectModelData } from '../../store/filterData/selector';
import { fetchData } from '../../store/filterData/actions';
import { transformDataForFilters } from '../../utils/utilsGOS';
import React from 'react';
import { addDataGOS, deleteDataGOS, updateDataGOS as updateDataGOSAction, setLastUpdatedId } from '../../store/addForms/actions';
import { selectLastAddedId, selectLastDocId } from '../../store/addForms/selector';
import { updateDataGOS as updateDataGOSAPI } from '../../api/api';

const { sendEmailStrapi, deleteEmail } = emailAPI();

type FormValues = Omit<License, 'id' | 'status'> & {
  periodicNotificationUpdateDate?: { id: number; name: string };
  frequencyRepeatedNotifications?: number;
};

type LicenseFormProps = {
  initialValues?: Omit<License, 'status'>;
  isEdit?: boolean;
  isNewForm?: boolean;
  toggleDoing?: (value: boolean) => void;
};

function LicenseForm({ initialValues, toggleDoing, isEdit, isNewForm = false }: LicenseFormProps) {
  const dispatch = useAppDispatch();
  const [documentStatus, setDocumentStatus] = useState<LicenseStatus>(initialValues?.status?.licenseStatuses);
  const [actionStatus, setActionStatus] = useState<ActionStatus>('Нет действий');
  const [isDefinedTermsDocument, setIsDefinedTermsDocument] = useState(AnswerOptions[0]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isPrefilledDataLoading, setIsPrefilledDataLoading] = useState(false);
  const [isModalOpenAlert, setModalOpenAlert] = useState<boolean>(false);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState<boolean>(false);
  const [offArchiveModalOpen, setOffArchiveModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const [isFormDisabled, setIsFormDisabled] = useState(true);

  const isSavingRef = useRef(false);
  const lastIDFormRef = useRef<number | null>(null);

  const isFieldDisabled = initialValues?.IsArchived === true || isFormDisabled;

  const currentUser = useAppSelector((state) => selectCurrentUser(state));

  const locationFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-locations'));
  const typeActivityFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-activities'));
  const typeDocumentFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-document-types'));
  const governmentAgencySelectData = useAppSelector((state: any) => selectModelData(state, 'gos-government-agencies'));
  const actionStatusFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-action-statuses'));
  const licenseStatusFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-license-statuses'));
  const params: any = useAppSelector((state) => selectItems(state, paramsListName));

  const { infoGOS } = useAppSelector(selectCurrentUser);

  const lastIDForm = useAppSelector((state) => selectLastAddedId(state, 'gos-licenses'));
  const licensesDocumentId = useAppSelector((state) => selectLastDocId(state, 'gos-licenses'));

  const locationFilter = React.useMemo(() => transformDataForFilters(locationFilterData), [locationFilterData]);
  const typeActivityFilter = React.useMemo(() => transformDataForFilters(typeActivityFilterData), [typeActivityFilterData]);
  const typeDocumentFilter = React.useMemo(() => transformDataForFilters(typeDocumentFilterData), [typeDocumentFilterData]);
  const governmentAgencySelect = React.useMemo(() => transformDataForFilters(governmentAgencySelectData), [governmentAgencySelectData]);
  const actionStatusFilter = React.useMemo(() => transformDataForFilters(actionStatusFilterData), [actionStatusFilterData]);
  const licenseStatusFilter = React.useMemo(() => transformDataForFilters(licenseStatusFilterData), [licenseStatusFilterData]);
  
  //! Получаю локации, тип деятельности, тип документа, гос орган, статусы действий, статусы лицензий
      useEffect(() => {
        dispatch(
          fetchData(
            'gos-locations',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
        dispatch(
          fetchData(
            'gos-activities',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
        dispatch(
          fetchData(
            'gos-document-types',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
        dispatch(
          fetchData(
            'gos-government-agencies',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
          dispatch(
          fetchData(
            'gos-action-statuses',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
            dispatch(
          fetchData(
            'gos-license-statuses',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
      }, [dispatch]);


  const defaultResponsible: any = {
    id: null,
    email: currentUser.email,
    title: currentUser.displayName,
    avatar: currentUser.avatar,
    shortName: currentUser.shortName,
  };

  const defaultValues: FormValues = {
    location: null,
    typeActivity: null,
    documentType: null,
    nameDocument: '',
    documentNumber: null,
    startDateDocument: null,
    expirationDateDocument: null,
    validityPeriodDocument: null,
    detailedDescription: '',
    governmentAgency: null,
    namesStateBody: '',
    responsible: defaultResponsible,
    interestedParties: [],
    dateUpdate: null,
    comment: '',
    products: '',
    ND: '',
    code_TN_VED: '',
    code_OKPD: '',
    codeTypeAlcoholicBeverages: '',
    certificationBody: '',
    GTD_samples: '',
    transferDeclarationBroker: '',
    IsArchived: false,

    periodicNotificationUpdateDate: AnswerOptions[0],
    frequencyRepeatedNotifications: 7,
  };

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, isDirty },
  } = useForm<FormValues>({
    defaultValues: initialValues || defaultValues,
    mode: 'onChange',
  });

  useEffect(() => {
    let state = true;
    if (infoGOS.editor) {
      if (initialValues?.location) {
        if (infoGOS.factoryIds.indexOf(initialValues?.location.id) >= 0) {
          state = false;
        }
      } else {
        state = false;
      }
    }
    if (infoGOS.admin) {
      state = false;
    }
    setIsFormDisabled(state);
  }, [infoGOS, initialValues?.location]); useEffect(() => {
    lastIDFormRef.current = lastIDForm;
  }, [lastIDForm]);

  //! обновление карточки
  const onSubmit = (data: FieldValues) => {
    isSavingRef.current = true;
    const statusId = getLicenseStatusId(documentStatus, licenseStatusFilter);

    const requestBody = {
      ID: isEdit ? initialValues?.id : lastIDForm,
      Title: `Licenses`,
      GOSLocation: data.location.id,
      TypeActivity: data.typeActivity.id,
      DocumentType: data.documentType.id,
      NameDocument: data.nameDocument,
      DocumentNumber: data.documentNumber,
      StartDateDocument: data.startDateDocument?.startDate ? new Date(data.startDateDocument.startDate) : null,
      ExpirationDateDocument: data.expirationDateDocument?.startDate ? new Date(data.expirationDateDocument.startDate) : null,
      ValidityPeriodDocument: data.validityPeriodDocument ? String(data.validityPeriodDocument) : null,
      DetailedDescription: data.detailedDescription,
      GovernmentAgency: data.governmentAgency.id,
      NamesStateBody: data.namesStateBody,
      // Responsible: data.responsible?.email,
      ResponsibleEmail: data.responsible?.email || data.Responsible?.Email,
      // InterestedParties: data.interestedParties.map((u: any) => u.email),
      InterestedPartiesEmails: data.interestedParties.map((u: any) => u.email),
      DateUpdate: data.dateUpdate?.startDate ? new Date(data.dateUpdate.startDate) : null,
      Comment: data.comment || '',
      Products: data.products ? data.products : '-',
      ND: data.ND ? data.ND : '-',
      Code_TN_VED: data.code_TN_VED ? data.code_TN_VED : '-',
      Code_OKPD: data.code_OKPD ? data.code_OKPD : '-',
      CodeTypeAlcoholicBeverages: data.codeTypeAlcoholicBeverages ? data.codeTypeAlcoholicBeverages : '-',
      CertificationBody: data.certificationBody ? data.certificationBody : '-',
      GTD_samples: data.GTD_samples ? data.GTD_samples : '-',
      TransferDeclarationBroker: data.transferDeclarationBroker ? data.transferDeclarationBroker : '-',
      LicenseStatus: statusId,
      // ActionStatuses: 1,//! удалить и с БД тоже
      // IsArchived: false,
      FrequencyRepeatedNotifications: data.periodicNotificationUpdateDate?.name === 'Да' ? data.frequencyRepeatedNotifications : 0,
      PeriodicNotificationUpdateDate: !data.dateUpdate ? '-' : data.periodicNotificationUpdateDate.name === 'Да' ? 'да' : 'нет',
    };

    // console.log('Запись в БД', requestBody);
    //! обновление заполненной карточки

    let emails = [data.responsible?.email];

    if (data.interestedParties.length > 0) {
      emails = [...emails, ...data.interestedParties.map((item: any) => item.email)];
    }

    let emailIDs: any = [];

    // console.log('statusId', statusId);

    getItemsRequest({
      listName: emailQueueListName,
      filters: {
        GosId: '' + requestBody.ID
      },
    })
      .then((results) => {
        const { items, nextPage: newNextPage } = results;

        if (items.length > 0) {
          emailIDs = items.map((item) => ({
            ID: Number(item.ID)
          }));
        }

        const timestamp = moment().unix();

        if (statusId === 3 && data.expirationDateDocument?.startDate) {
          // <li>Название документа: ${data.nameDocument}</li>

          const emailBody = {
            Body: `Здравствуйте!<br/><br/>
              Примите к сведению, что документ № <a href="${siteUrl}/dashboard/4/licenses?licenseCard=${requestBody.ID}">${data.documentNumber}</a> просрочен: <br/><br/>
              <ul>
                <li>Завод: ${data.location.name}</li>
                <li>Дата начала действия документа: ${moment(data.startDateDocument.startDate).format('DD.MM.YYYY')}</li>
                <li>Дата окончания действия документа: <strong style="color:red;">${moment(data.expirationDateDocument.startDate).format('DD.MM.YYYY')}</strong></li>
              </ul>`,
            DateToBeSentAt: moment().subtract(25, "hours").toDate(),
            Title: "Гос Требования | Документ просрочен",
            Subject: "Гос Требования | Документ просрочен",
            Recepients: emails.join(', '),
            RepeatAt: params && Number(params.find((param: any) => param.Key === "LicenseExpired")["Value"].trim()) || 1440 * 7,
            RepeatTimes: 100000,
            RepeatTimesValue: 0,
            GosId: String(requestBody.ID),
            CheckDoc: String(timestamp),
          };
          Promise.all([sendEmailStrapi(emailBody)]);

        }

        console.log('statusId', statusId);

        if ((statusId == 1 || statusId == 2) && data.expirationDateDocument?.startDate) {

          // let statusSend = true;

          // if(!isEdit && statusId === 3){
          //   statusSend = false;
          // }

          // if(statusSend){
          const emailBody2 = {
            Body: `Здравствуйте!<br/><br/>
                Примите к сведению, что близится дата окончания срока действия документа № <a href="${siteUrl}/dashboard/4/licenses?licenseCard=${requestBody.ID}">${data.documentNumber}</a>: <br/><br/>
                <ul>
                  <li>Завод: ${data.location.name}</li>
                  <li>Дата начала действия документа: ${moment(data.startDateDocument.startDate).format('DD.MM.YYYY')}</li>
                  <li>Дата окончания действия документа: <strong style="color:red;">${moment(data.expirationDateDocument.startDate).format('DD.MM.YYYY')}</strong></li>
                </ul>`,
            DateToBeSentAt: moment(requestBody.ExpirationDateDocument).subtract(2, 'months').toDate(),
            Title: "Гос Требования | Уведомление о документе",
            Subject: "Гос Требования | Уведомление о документе",
            Recepients: emails.join(', '),
            RepeatAt: 0,
            RepeatTimes: 1,
            RepeatTimesValue: 0,
            GosId: String(requestBody.ID),
            CheckDoc: String(timestamp),
          };

          if (requestBody.DateUpdate) {
            emailBody2.DateToBeSentAt = moment(requestBody.DateUpdate).toDate();
            emailBody2.RepeatAt = 1440 * requestBody.FrequencyRepeatedNotifications;
            emailBody2.RepeatTimes = requestBody.FrequencyRepeatedNotifications > 0 ? 100000 : 1;
          }

          Promise.all([sendEmailStrapi(emailBody2)]);
          // }
        }

        const { ID, Title, ...strapiData } = requestBody;

        if (isEdit) {
          dispatch(updateDataGOSAction('gos-licenses', initialValues?.docId, strapiData));

        } else {
          //! обновление пустой карточки которая сохранилась при открытии модалки
          dispatch(updateDataGOSAction('gos-licenses', licensesDocumentId, strapiData));

          // <li>Тип деятельности: ${data.typeActivity.name}</li>
          // <li>Тип документы: ${data.documentType.name}</li>
          // <li>Название документа: ${data.nameDocument}</li>

        }

        deleteEmail(emailIDs);
      })
      .catch((error) => {
        console.error('Ошибка при сохранении лицензии:', error);
      });

    toggleDoing?.(false);
  };

  // useEffect(() => {
  //   return () => {
  //     if (!isSavingRef.current && isNewForm && lastIDFormRef.current) {
  //       dispatch(
  //         deleteItem({
  //           listName: licensesList,
  //           ID: lastIDFormRef.current,
  //           updateReducer: true,
  //           anySite: UrlGOS,
  //         })
  //       );
  //     }
  //   };
  // }, []);

  const dateUpdate = watch('dateUpdate');
  const isAddDateUpdate = dateUpdate?.startDate;
  const isAddNotification = watch('periodicNotificationUpdateDate');

  const valueTypeActivity = watch('typeActivity');
  const watchedValues = watch();
  const requiredFields: (keyof FormValues)[] = [
    'location',
    'typeActivity',
    'documentType',
    'nameDocument',
    'documentNumber',
    'detailedDescription',
    'governmentAgency',
    'responsible',
    'namesStateBody',
    'interestedParties',
  ];

   const isSubmitDisabled = requiredFields.some((field) => {
    const value = watchedValues[field];

    if (Array.isArray(value)) {
      return value.length === 0 || errors[field];
    }
    return !value || errors[field];
  });

  const handleSelectDefinedTermsDocument = (newValue: { id: number; name: string }) => {
    setIsDefinedTermsDocument(newValue);
  };

  //! при нажатии на отмену, автосохраненная запись удаляется
  const cancel = useCallback(() => {
    isSavingRef.current = false;
    if (isNewForm && licensesDocumentId) {
      dispatch(deleteDataGOS('gos-licenses', licensesDocumentId));
    }
    toggleDoing(false);
  }, [isNewForm, licensesDocumentId, dispatch, toggleDoing]);

  const onCancelEditClick = () => {
    if (isEdit && isDirty) {
      setModalOpenAlert(true);
    } else {
      toggleDoing?.(false);
    }
  };

  //! автосохранение пустой записи при открытии модалки
  useEffect(() => {
    if (isNewForm && !isPrefilledDataLoading) {
      const requestBody = formatEmptyLicenseBody(documentStatus, actionStatus, defaultResponsible, licenseStatusFilter, actionStatusFilter);
      dispatch(addDataGOS('gos-licenses', requestBody));
    }
  }, [isNewForm, isPrefilledDataLoading]);

  useEffect(() => {
    if (lastIDForm && lastIDForm > 0) {
      setIsDialogOpen(true);
    }
  }, [lastIDForm]);

  //! для отслеивания полей дат
  const watchStartDate = watch('startDateDocument');
  const watchEndDate = watch('expirationDateDocument');

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      console.log('initialValues.id', initialValues);
      try {
        // if (initialValues?.id) {
        //   await getItemsRequest({
        //     listName: licensesList,
        //     filters: { ID: initialValues.id },
        //     anySite: UrlGOS,
        //   });
        // }
      } catch (error) {
        console.error('Error initializing data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeData();
  }, [dispatch]);

  const handleArchiveModal = useCallback(() => {
    setIsArchiveModalOpen(true);
  }, []);

  const handleOffArchiveModal = useCallback(() => {
    setOffArchiveModalOpen(true);
  }, []);

  //! обновление срока действия
  useEffect(() => {
    const updateStatus = async () => {
      setIsProcessing(true);
      try {
        const { startDate, endDate } = getFormattedDates(watchStartDate, watchEndDate, initialValues);
        const newStatus = determineLicenseStatus(startDate, endDate, initialValues?.IsArchived === true);
        setDocumentStatus(newStatus);
        const validityPeriod = updateValidityPeriod(watchStartDate, watchEndDate, calculateValidityPeriod);
        setValue('validityPeriodDocument', validityPeriod);
      } catch (error) {
        console.error('Ошибка при обновлении статуса:', error);
      } finally {
        setIsProcessing(false);
      }
    };
    const timeoutId = setTimeout(updateStatus, 500);
    return () => clearTimeout(timeoutId);
  }, [watchStartDate, watchEndDate, initialValues, documentStatus, licenseStatusFilter, dispatch, calculateValidityPeriod, setValue, isProcessing, isLoading]);

//! архивирование и разархивирование
  const handleArchiveStatusChange = useCallback(
    async (isArchiving: boolean) => {
      if (isProcessing) return;
      setIsProcessing(true);
      try {
        const docIdToUpdate = isEdit ? initialValues?.docId : licensesDocumentId;

        if (docIdToUpdate) {
          let updatedStatusId = null;

          if (isArchiving) {
            updatedStatusId = getLicenseStatusId('В архиве', licenseStatusFilter);
          } else {
            const { startDate, endDate } = getFormattedDates(watchStartDate, watchEndDate, initialValues);
            const newStatus = determineLicenseStatus(startDate, endDate, false);
            updatedStatusId = getLicenseStatusId(newStatus, licenseStatusFilter);
          }

          const updateData: any = {
            IsArchived: isArchiving,
            LicenseStatus: updatedStatusId,
          };
          await updateDataGOSAPI('gos-licenses', docIdToUpdate, updateData);

          const licenseId = isEdit ? initialValues?.id : lastIDForm;
          dispatch(setLastUpdatedId('gos-licenses', licenseId));
          if (initialValues) {
            initialValues.IsArchived = isArchiving;
          }

          if (updatedStatusId !== null) {
            const licensesStatusesMap: Record<number, string> = {
              1: 'В процессе',
              2: 'Действующий',
              3: 'Просрочен',
              4: 'В архиве',
            };
            const newStatusName = licensesStatusesMap[updatedStatusId] || 'В процессе';
            setDocumentStatus(newStatusName as any);
          }

          let emailIDs: any = [];

          const idToSearch = isEdit ? initialValues?.id : lastIDForm;

          getItemsRequest({
            listName: emailQueueListName,
            filters: {
              GosId: '' + idToSearch
            },
          })
            .then((results) => {
              const { items } = results;
              if (items.length > 0) {
                emailIDs = items.map((item) => ({
                  ID: Number(item.ID)
                }));
              }

              deleteEmail(emailIDs);
            });
        }
      } catch (error) {
        console.error(`Ошибка при ${isArchiving ? 'архивации' : 'разархивации'}:`, error);
      } finally {
        setIsProcessing(false);
        setIsArchiveModalOpen(false);
        setOffArchiveModalOpen(false);
      }
    },
    [dispatch, isEdit, initialValues, lastIDForm, licensesDocumentId, isProcessing, watchStartDate, watchEndDate, licenseStatusFilter]
  );

  const renderAdditionalInformation = (value: { name: TypeActivity }) => {
    if (!valueTypeActivity) {
      return (
        <Controller
          control={control}
          name='comment'
          render={({ field: { onChange, value } }) => <Input label='Комментарий' disabled={isFieldDisabled} value={value} placeholder='Введите комментарий' onChange={onChange} />}
        />
      );
    }

    switch (value.name) {
      case 'Экология':
        return (
          <div className='mt-5 flex flex-col gap-5'>
            <Select
              data={AnswerOptions}
              selected={isDefinedTermsDocument}
              disabled={isFieldDisabled}
              label='Определены ли условия действия этого документа?'
              required
              onChange={handleSelectDefinedTermsDocument}
              width='w-full'
            />
            {isDefinedTermsDocument.name === 'Да' && <div className='bg-[#FEF3C7] rounded-md border border-[#F2A900] flex justify-center p-3 text-black'>Необходимо создать хотя бы 1 действие</div>}
            <Controller
              control={control}
              name='comment'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Комментарий',
                    key: 'comment',
                    placeholder: 'Комментарий',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
          </div>
        );
      case 'Качество':
        return (
          <div className='mt-5 flex flex-col gap-5'>
            <Controller
              control={control}
              name='products'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Продукция',
                    key: 'products',
                    placeholder: 'Введите продукцию',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='ND'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'НД',
                    key: 'ND',
                    placeholder: 'Введите НД',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='code_TN_VED'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Код ТН ВЭД',
                    key: 'code_TN_VED',
                    placeholder: 'Введите Код ТН ВЭД',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='code_OKPD'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Код ОКПД 2',
                    key: 'code_OKPD',
                    placeholder: 'Введите Код ОКПД 2',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='codeTypeAlcoholicBeverages'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Код вида алкогольной продукции',
                    key: 'codeTypeAlcoholicBeverages',
                    placeholder: 'Введите код вида алкогольной продукции',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='certificationBody'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Орган по сертификации',
                    key: 'certificationBody',
                    placeholder: 'Введите орган по сертификации',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='GTD_samples'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'ГТД на образцы',
                    key: 'GTD_samples',
                    placeholder: 'Введите ГТД на образцы',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='transferDeclarationBroker'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Передача декларации брокерам (таможенный отдел)',
                    key: 'transferDeclarationBroker',
                    placeholder: 'Передача декларации брокерам (таможенный отдел)',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
            <Controller
              control={control}
              name='comment'
              render={({ field, fieldState: { error } }) => (
                <TextAreaVPO
                  dataField={{
                    type: 'textArea',
                    require: false,
                    width: 'w-full',
                    title: 'Комментарий',
                    key: 'comment',
                    placeholder: 'Комментарий',
                  }}
                  value={field.value}
                  disabled={isFieldDisabled}
                  onChange={field.onChange}
                  errors={{}}
                  minHeight={48}
                />
              )}
            />
          </div>
        );
      default:
        return (
          <Controller
            control={control}
            name='comment'
            render={({ field, fieldState: { error } }) => (
              <TextAreaVPO
                dataField={{
                  type: 'textArea',
                  require: false,
                  width: 'w-full',
                  title: 'Комментарий',
                  key: 'comment',
                  placeholder: 'Комментарий',
                }}
                value={field.value}
                disabled={isFieldDisabled}
                onChange={field.onChange}
                errors={{}}
                minHeight={48}
              />
            )}
          />
        );
    }
  };

  return (
    <>
      {isLoading && (
        <span className='flex items-center justify-center fixed inset-0 bg-white z-50'>
          <Loading />
        </span>
      )}
      {!isLoading && (
        <div className='p-10'>
          <div className='flex items-center gap-3 mb-8'>
            <h2 className='text-3xl mr-auto'>Документ</h2>
            <Status type={documentStatus} />
            {!isFormDisabled && (
              <div>
                <TooltipItem wrapperClassName='w-full' position='top-left' tooltipsText={isFieldDisabled ? 'Разархивировать' : 'Архивировать'}>
                  <div onClick={isFieldDisabled ? handleOffArchiveModal : handleArchiveModal}>{document}</div>
                </TooltipItem>
              </div>
            )}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <section>
              <div className='mb-5'>
                <Controller
                  control={control}
                  name='location'
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width='w-full'
                      data={
                        !infoGOS.admin && infoGOS.editor && infoGOS.factory || locationFilter?.map((item) => ({
                          id: item.ID,
                          name: item.Title || '',
                        })) || []
                      }
                      selected={value}
                      disabled={isFieldDisabled}
                      label='Локация'
                      placeholder='Выберите локацию'
                      required
                      onChange={onChange}
                    />
                  )}
                />
              </div>
              <div className='grid grid-cols-2 gap-5'>
                <Controller
                  control={control}
                  name='typeActivity'
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width='w-full'
                      data={
                        typeActivityFilter?.map((item) => ({
                          id: item.ID,
                          name: item.Title || '',
                        })) || []
                      }
                      selected={value}
                      disabled={isFieldDisabled}
                      label='Тип деятельности'
                      placeholder='Выберите тип деятельности'
                      required
                      onChange={onChange}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name='documentType'
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width='w-full'
                      data={
                        typeDocumentFilter?.map((item) => ({
                          id: item.ID,
                          name: item.Title || '',
                        })) || []
                      }
                      selected={value}
                      disabled={isFieldDisabled}
                      label='Тип документа'
                      placeholder='Выберите тип документа'
                      required
                      onChange={onChange}
                    />
                  )}
                />
              </div>
              <div className='mt-5 flex flex-col gap-5'>
                <Controller
                  control={control}
                  name='nameDocument'
                  render={({ field, fieldState: { error } }) => (
                    <TextAreaVPO
                      dataField={{
                        type: 'textArea',
                        require: true,
                        width: 'w-full',
                        title: 'Название документа',
                        key: 'nameDocument',
                        placeholder: 'Введите название документа',
                      }}
                      value={field.value}
                      disabled={isFieldDisabled}
                      onChange={field.onChange}
                      errors={{ nameDocument: error }}
                      minHeight={48}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name='documentNumber'
                  render={({ field, fieldState: { error } }) => (
                    <TextAreaVPO
                      dataField={{
                        type: 'textArea',
                        require: true,
                        width: 'w-full',
                        title: 'Номер документа',
                        key: 'documentNumber',
                        placeholder: 'Введите номер документа',
                      }}
                      value={field.value}
                      disabled={isFieldDisabled}
                      onChange={field.onChange}
                      errors={{ documentNumber: error }}
                      minHeight={48}
                    />
                  )}
                />
              </div>
              <div className='grid grid-cols-3 gap-5 mt-5'>
                <Controller
                  control={control}
                  name='startDateDocument'
                  render={({ field: { onChange, value } }) => <InputDate label='Дата начала действия документа' value={value as DateValueType} onChange={onChange} disabled={isFieldDisabled} />}
                />
                <Controller
                  control={control}
                  name='expirationDateDocument'
                  render={({ field: { onChange, value } }) => <InputDate label='Дата окончания действия документа' value={value as DateValueType} onChange={onChange} disabled={isFieldDisabled} />}
                />
                <Controller
                  control={control}
                  name='validityPeriodDocument'
                  render={({ field: { value, onChange } }) => <Input label='Срок действия документа, лет' value={value || ''} placeholder='—' disabled={true} onChange={onChange} />}
                />
              </div>
              <div className='mt-5 flex flex-col gap-5'>
                <Controller
                  control={control}
                  name='detailedDescription'
                  render={({ field, fieldState: { error } }) => (
                    <TextAreaVPO
                      dataField={{
                        type: 'textArea',
                        require: true,
                        width: 'w-full',
                        title: 'Детальное описание',
                        key: 'detailedDescription',
                        placeholder: 'Введите детальное описание',
                      }}
                      value={field.value}
                      disabled={isFieldDisabled}
                      onChange={field.onChange}
                      errors={{ detailedDescription: error }}
                      minHeight={48}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name='governmentAgency'
                  render={({ field: { onChange, value } }) => (
                    <Select
                      width='w-full'
                      data={
                        governmentAgencySelect?.map((item) => ({
                          id: item.ID,
                          name: item.Title || '',
                        })) || []
                      }
                      selected={value}
                      disabled={isFieldDisabled}
                      label='Государственный орган'
                      placeholder='Выберите государственный орган'
                      required
                      onChange={onChange}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name='namesStateBody'
                  render={({ field, fieldState: { error } }) => (
                    <TextAreaVPO
                      dataField={{
                        type: 'textArea',
                        require: true,
                        width: 'w-full',
                        title: 'Наименования государственного органа',
                        key: 'namesStateBody',
                        placeholder: 'Введите наименования государственного органа',
                      }}
                      value={field.value}
                      disabled={isFieldDisabled}
                      onChange={field.onChange}
                      errors={{ namesStateBody: error }}
                      minHeight={48}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name='responsible'
                  defaultValue={defaultResponsible}
                  render={({ field: { onChange, value } }) => <SingleUserSelect selectedUser={value} onUserSelect={onChange} disabled={isFieldDisabled} label='Ответственный' required />}
                />
                <Controller
                  control={control}
                  name='interestedParties'
                  render={({ field: { onChange, value } }) => (
                    <div className='w-full'>
                      <div className='mb-2 flex justify-between'></div>
                      <UserSelect label='Заинтересованные лица' required={true} selectedUsers={value} onUserFilterChange={onChange} disabled={isFieldDisabled} />
                    </div>
                  )}
                />
              </div>
            </section>
            <section className='mt-8'>
              <div className='flex items-center mb-4'>
                <h4 className='text-base text-primaryGray'>Обновление</h4>
              </div>

              <div className='flex flex-col gap-5'>
                <Controller
                  control={control}
                  name='dateUpdate'
                  render={({ field: { onChange, value } }) => (
                    <InputDate
                      label='Дата обновления'
                      value={value as DateValueType}
                      onChange={onChange}
                      disabled={isFieldDisabled}
                      description='В указанную дату придет уведомление со ссылкой на документ на почту ответственного и заинтересованных лиц'
                    />
                  )}
                />

                {isAddDateUpdate && (
                  <Controller
                    control={control}
                    name='periodicNotificationUpdateDate'
                    render={({ field: { onChange, value } }) => (
                      <Select data={AnswerOptions} selected={value} disabled={isFieldDisabled} label='Необходимо периодическое уведомление после даты обновления?' required onChange={onChange} />
                    )}
                  />
                )}

                {isAddNotification?.name === 'Да' && isAddDateUpdate && (
                  <Controller
                    control={control}
                    name='frequencyRepeatedNotifications'
                    render={({ field: { onChange, value } }) => <Input label='Периодичность повторных уведомлений в днях' value={value} onChange={onChange} disabled={isFieldDisabled} />}
                  />
                )}
              </div>
            </section>
            <section className='mt-8'>
              <div className='flex items-center mb-4'>
                <h4 className='text-base text-primaryGray'>Дополнительная информация</h4>
              </div>
              {renderAdditionalInformation(valueTypeActivity)}
            </section>
          </form>
          <section className='mt-8'>
            <div className='flex items-center mb-5'>
              <h4 className='text-base text-primaryGray'>Действия</h4>
              <span className='ml-auto mr-5'>Статус действий</span>
              <Status type={initialValues?.actionStatus} />
            </div>
            {(lastIDForm > 0 || (initialValues?.id && initialValues?.id > 0)) && !isLoading && (
              <div className={isFieldDisabled ? 'cursor-not-allowed' : ''}>
                <AddActionInComponent
                  typeModule={'Лицензии'}
                  idModule={lastIDForm || initialValues?.id}
                  CustomStyles={`bg-white p-5 ${isFieldDisabled ? 'opacity-90 pointer-events-none' : ''}`}
                  customTypes={`add_action_in_component_${lastIDForm}`}
                />
              </div>
            )}
          </section>
          <section className='mt-8'>
            <div className='flex items-center mb-4'>
              <h4 className='text-base text-[#637381]'>Вложения · {fileCount}</h4>
            </div>
            <FileUploader itemId={initialValues?.id ?? lastIDForm} listName='LicensesUpload' idFieldName='LicensesID' onFileCountChange={setFileCount} />
          </section>
          <form onSubmit={handleSubmit(onSubmit)}>
            <section className='mt-8 flex justify-between'>
              <TGButton type='button' onClick={isEdit ? onCancelEditClick : cancel}>
                Отмена
              </TGButton>
              {!isFormDisabled && (
                <>
                  {isEdit ? (
                    <TGButton type='submit' color='bluedark' disabled={isSubmitDisabled}>
                      Сохранить
                    </TGButton>
                  ) : (
                    <TGButton type='submit' color='bluedark' disabled={isSubmitDisabled}>
                      Сохранить
                    </TGButton>
                  )}
                </>
              )}
            </section>
          </form>
          {isEdit && (
            <AlertInformation
              isOpen={isModalOpenAlert}
              title='Вы действительно хотите отменить изменения?'
              text="При нажатии 'Отмена' возврат действий будет невозможен"
              onClose={() => setModalOpenAlert(false)}
              onCloseForm={() => toggleDoing(false)}
            />
          )}
          <AlertArchive
            isOpen={isArchiveModalOpen}
            title='Подтвердите действие'
            text='Вы уверены, что хотите архивировать лицензию?
              Ее нельзя будет изменить, пока она в архиве.'
            onClose={() => setIsArchiveModalOpen(false)}
            onCloseForm={async () => {
              await handleArchiveStatusChange(true);
            }}
            isProcessing={isProcessing}
          />
          <AlertArchive
            isOpen={offArchiveModalOpen}
            offArchive={true}
            title='Подтвердите действие'
            text='Вы уверены, что хотите разархивировать лицензию?
            Лицензию можно будет изменить.'
            onClose={() => setOffArchiveModalOpen(false)}
            onCloseForm={async () => {
              await handleArchiveStatusChange(false);
            }}
            isProcessing={isProcessing}
          />
        </div>
      )}
    </>
  );
}

export default LicenseForm;
